import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Card, CardContent, Typography, IconButton } from '@mui/material'
import ErrorIcon from '@mui/icons-material/Error'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import { ResponseForm } from './response-form.component'
import { SuccessIcon, LinkIcon } from 'src/assets/icons'

import { IHealthCheck } from 'src/types'
import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { AppEvents } from 'src/constants'

interface IProps {
  items?: IHealthCheck[] | void
}

export const ListView = ({ items }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const [formInitValues, setFormInitValues] = useState<Object | null>(null)

  const handleOpen = (val: IHealthCheck) => () => {
    setFormInitValues(val.response)
  }

  const handleClose = () => {
    setFormInitValues(null)
  }

  const handleCopyClick = (link?: string) => {
    if (!link) {
      return
    }

    const detail = { message: t('clipboard-copied-notification.v') }
    const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
    document.dispatchEvent(event)

    navigator.clipboard.writeText(link)
  }

  return (
    <div className={classes.cardsWrapper}>
      {items?.map((item) => (
        <Card key={item.name} className={classes.cardWrapper}>
          <CardContent className={classes.cardContent}>
            <div className={classes.cardLeftWrapper}>
              <Typography className={classes.cardName}>{item.name}</Typography>
            </div>
            {item?.endpoint_link && (
              <div>
                <IconButton
                  sx={{
                    padding: '0.375rem',
                  }}
                  disabled={!item?.endpoint_link}
                  onClick={() => {
                    handleCopyClick(item?.endpoint_link)
                  }}
                >
                  <ContentCopyIcon className={classes.linkIcon} />
                </IconButton>
                <IconButton
                  sx={{
                    padding: '0.375rem',
                  }}
                  disabled={!item?.endpoint_link}
                  component="a"
                  href={
                    item.endpoint_link?.includes('http')
                      ? item.endpoint_link
                      : `//${item.endpoint_link}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkIcon className={classes.linkIcon} />
                </IconButton>
              </div>
            )}
            <div className={classes.cardRightWrapper}>
              {item.success ? (
                <SuccessIcon className={classes.successIcon} />
              ) : (
                <ErrorIcon className={classes.failureIcon} />
              )}
              <Button disabled={item.success} type="button" onClick={handleOpen(item)}>
                <HelperWrapper t="response-button-text" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}

      <ResponseForm values={formInitValues} open={!!formInitValues} handleClose={handleClose} />
    </div>
  )
}
